export default {
  en: {
    markAllAsRead: 'Mark all as read',
    noNotifications: 'No new notifications',
    showAll: 'Show all notifications',
  },
};
